<template>
    <MainPage
        :subPageName="subPageName"
        @updateSubPageName="updateSubPageName()"
        @clickBack="clickBack()"
        >
        <template v-slot:header>
            <div class="header-title">
                {{ subPageName ? subPageName : 'Privacy Setting'}}
            </div>
        </template>
        <div class="setting-container">
            <div v-if="isDefaultState">
                <div class="setting-item" @click="changeState('terms', 'Terms & Conditions')">
                    <div class="title">Terms & Conditions</div>
                    <img src="../../../assets/icon/ic-arrw-setting.svg" alt="">
                </div>
                <div class="setting-item" @click="changeState('privacy', 'Privacy Policy')">
                    <div class="title">Privacy Policy</div>
                    <img src="../../../assets/icon/ic-arrw-setting.svg" alt="">
                </div>
                <div class="setting-item" @click="changeState('marketing', 'Marketing Message')">
                    <div class="title">Marketing Message</div>
                    <img src="../../../assets/icon/ic-arrw-setting.svg" alt="">
                </div>
            </div>
            <div v-show="isTermsState">
                <div>
                    <PdpaConsent :consent="terms" :title="subPageName"></PdpaConsent>
                </div>
            </div>
            <div v-show="isPrivacyState">
                <div>
                    <PdpaConsent :consent="privacy" :title="subPageName"></PdpaConsent>
                </div>
            </div>
            <div v-show="isMktState" class="">
                <div>
                    <MarketingConsent
                        :title="subPageName"
                        :consent="marketing"
                        :checkChanel="checkMarketing"
                        :modalController="modalController"
                        @onClick="onSubmit($event)"
                    >
                    </MarketingConsent>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modalController" />
    </MainPage>
</template>

<script>
import MainPage from '@/components/Layout/Page/MainPage.vue';
import BzbsPDPA from '@/core/PDPA/service/BzbsPDPA';
import ModalMixin from '@/mixin/ModalMixin';
import LocaleMixin from '@/mixin/LocaleMixin';
import PdpaConsent from '../component/PdpaConsent.vue';
import MarketingConsent from '../component/MarketingConsent.vue';
import Account from '@/helper/AccountHelper';
export default {
    name: "PrivacySetting",
    mixins:[ModalMixin,LocaleMixin],
    components: {
        MainPage,
        PdpaConsent,
        MarketingConsent,
    },
    data: function () {
        return {
            state: 'default',
            subPageName: null,

            versionTerms: null,
            versionPrivacy: null,
            versionMarketing: null,
            terms: null,
            privacy: null,
            marketing: null,

            checkMarketing:{
                email: false,
                sms: false
            }

        }
    },
    computed: {
        isDefaultState: function () {
            return !this.$route.params.type
        },
        isTermsState: function () {
            return this.$route.params.type == 'terms'
        },
        isPrivacyState: function () {
            return this.$route.params.type == 'privacy'
        },
        isMktState: function () {
            return this.$route.params.type == 'marketing'
        },

    },
    mounted: async function () {
        this.loadingModal.show();
        let success = await this.getVersion();
        if(success){
            await this.getTermsApi();
            await this.getPrivacyApi();
            await this.getMarketingConsentApi();
            await this.apiGetCurrentConsent();
        }
        this.loadingModal.hide();
        if (this.$route.params.type) {
            if(this.isTermsState){
                this.subPageName = this.lbl.privacySetting.terms_conditions
            }
            if(this.isPrivacyState){
                this.subPageName = this.lbl.privacySetting.privacy_policy
            }
            if(this.isMktState){
                this.subPageName = this.lbl.privacySetting.marketing_message
            }
        }
    },
    methods: {
        clickBack: function () {
            if (this.$route.path == '/main/privacysetting') {
                this.$router.back()
                return;
            }
            this.subPageName = null;
            this.$router.replace('/main/privacysetting')
        },
        updateSubPageName: function() {
            this.subPageName = null;
        },
        changeState: function (state, subPageName) {
            this.state = state;
            this.subPageName = subPageName;
            this.$router.push('/main/privacysetting/' + this.state)
        },
        getVersion: function(){
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAVersion().subscribe(data => {
                    this.versionPrivacy = data.privacy.current_version;
                    this.versionTerms = data.terms.current_version;
                    this.versionMarketing = data.marketingOption.current_version;
                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    resolve(false);
                });
            });
        },
        getTermsApi: function(){
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent('terms',this.versionTerms ,this.localeCode)
                .subscribe(data => {
                    this.terms = data;
                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    resolve(false);
                });
            });
        },
        getPrivacyApi: function(){
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent('privacy',this.versionPrivacy ,this.localeCode)
                .subscribe(data => {
                    this.privacy = data;
                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    resolve(false);
                });
            });
        },
        getMarketingConsentApi: function(){
            return new Promise((resolve) => {
                BzbsPDPA.apiGetPDPAContent('marketing',this.versionMarketing ,this.localeCode)
                .subscribe(data => {
                    this.marketing = data;
                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    resolve(false);
                });
            });
        },
        onSubmit: async function(marketingCheck){
            let marketing = {
                sms : marketingCheck.sms ? this.versionMarketing : -1,
                email : marketingCheck.email ? this.versionMarketing : -1,
            }
            this.loadingModal.show();
            await this.apiUpdateConsent(marketing);
            this.loadingModal.hide();
        },
        apiUpdateConsent: function(marketing){
            let token = Account.getToken();
            let termandcondition = this.versionTerms;
            let dataprivacy = this.versionPrivacy;
            return new Promise((resolve) => {
                BzbsPDPA.apiUpdateConsent(token,termandcondition,dataprivacy,marketing)
                .subscribe(data => {
                    console.log(data)
                    this.modalController.alertModal.setTitle(this.lbl.privacySetting.success.title).setBtnOk(this.lbl.privacySetting.success.btn).show();
                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    resolve(false);
                });
            });
        },
        apiGetCurrentConsent: function(){
            this.modalController.loadingModal.show();
            let token = Account.getToken();
            return new Promise((resolve) => {
                BzbsPDPA.apiGetCurrentConsent(token)
                .subscribe(data => {
                    this.checkMarketing.sms = data.SMSMarketing ? true : false
                    this.checkMarketing.email = data.EmailMarketing ? true : false
                    this.modalController.loadingModal.hide();
                    resolve(true);
                }, (err) => {
                    this.errorApi(err);
                    this.modalController.loadingModal.hide();
                    resolve(false);
                });
            });
        },
        errorApi: function(err){
            this.alertModal.setMsg(err.msg).show();
        }
    }

}
</script>

<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/base/baseDisplay.scss";
    @import "@/style/base/baseUtility.scss";
    @import "../style/PrivacySetting.scss";
</style>
